import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Stopwatch = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("polygon", { points: "15.8,4.7 9.8,4.7 9.8,6.2 12,6.2 12,6.5 13.5,6.5 13.5,6.2 15.8,6.2 " }),
    React.createElement("rect", { x: "12", y: "10.5", width: "1.5", height: "3" }),
    React.createElement("path", { fill: "none", d: "M18.3,13.5c0,3-2.5,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C15.8,8,18.3,10.5,18.3,13.5z" }),
    React.createElement("path", { d: "M12.8,19.5c-3.3,0-6-2.7-6-6c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6C18.8,16.8,16.1,19.5,12.8,19.5z M12.8,9\n\t\tc-2.5,0-4.5,2-4.5,4.5c0,2.5,2,4.5,4.5,4.5c2.5,0,4.5-2,4.5-4.5C17.3,11,15.2,9,12.8,9z" })), 'Stopwatch');
export default Stopwatch;
